import React from 'react';
import OwlCarousel from "react-owl-carousel-rtl";
import '../../../node_modules/owl.carousel/dist/assets/owl.carousel.css'
import '../../../node_modules/owl.carousel/dist/assets/owl.theme.default.css';
import '../../assets/css/shimmer.css'

const LoaderCoustomerComments = ({ customerCm }) => {
    // console.log(customerCm);

    return (
        <div className="coustomer-comments">

            <div className="block-title">
                <h6 className="title">نظرات مشتریان</h6>
            </div>

            <div className='row'>
                <div className='col-md-6 '>
                    <div className="testimonial shimmerBox">
                        <div className="image">
                            <div className="shine shimmerBoxIn"></div>
                        </div>
                        <div className="cm">
                            <div className="shine shimmerLine"></div>
                        </div>
                        <div className="author-info">
                            <div className="author-nm">
                                <div className="shine shimmerLine"></div>
                            </div>
                            <div className="company">
                                <div className="shine shimmerLine"></div>
                            </div>
                            <div className="icon"><i className="far fa-quote-right"></i></div>
                        </div>
                    </div>
                </div>
                <div className='col-md-6 d-none d-md-block'>
                    <div className="testimonial shimmerBox">
                        <div className="image">
                            <div className="shine shimmerBoxIn"></div>
                        </div>
                        <div className="cm">
                            <div className="shine shimmerLine"></div>
                        </div>
                        <div className="author-info">
                            <div className="author-nm">
                                <div className="shine shimmerLine"></div>
                            </div>
                            <div className="company">
                                <div className="shine shimmerLine"></div>
                            </div>
                            <div className="icon"><i className="far fa-quote-right"></i></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default LoaderCoustomerComments;